import en from "../i18n/locales/en.json";
import pl from "../i18n/locales/pl.json";
import cs from "../i18n/locales/cs.json";
import de from "../i18n/locales/de.json";
import it from "../i18n/locales/it.json";

// Translation function
export function translate(key: string): string {
  const runtimeConfig = useRuntimeConfig();

  const locale = runtimeConfig.public.locale || "en";

  const translations =
    locale === "pl"
      ? pl
      : locale === "cs"
        ? cs
        : locale === "de"
          ? de
          : locale === "it"
            ? it
            : en;

  // Split the key into parts (e.g., 'common.header')
  const keys = key.split(".");

  // Use reduce to traverse the nested structure of the translation file
  const value =
    keys.reduce((acc, part) => {
      // If part exists in the object, continue; otherwise, return the key (fallback)
      return acc && acc[part] ? acc[part] : key;
    }, translations) || key; // Return the key as fallback if not found

  return unwrapTranslation(value);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function unwrapTranslation(value: any): string {
  if (value && typeof value === "object") {
    if ("static" in value) return value.static;
    if (
      "body" in value &&
      typeof value.body === "object" &&
      "static" in value.body
    )
      return value.body.static;
  }

  if (typeof value === "string") return value;

  return String(value);
}
